/* Bark & Bitter product pages: section bars, recipe tabs, accordions, multi-item add to cart and quick view links.
   Works with sections/bbp-product.liquid. No dependencies; uses the theme's cart drawer when it's there. */
(function () {
  'use strict';

  var PHONE = window.matchMedia('(max-width: 767px)');

  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* ---------- Sticky offset: keep the bars below the theme's header whenever it's showing ---------- */
  function headerBottom() {
    var best = 0;
    var cands = qsa(document, '.header-mobile, .header-wrapper, .header-bottom, [data-sticky-type], sticky-header, .section-header-navigation, .shopify-section-header-sticky, #shopify-section-header, .header');
    cands.forEach(function (el) {
      if (el.closest('.bbp')) return;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') return;
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height <= 0 || r.height > 220) return;
      if (r.top > 2 || r.bottom <= 0) return;
      if (r.bottom > best) best = r.bottom;
    });
    return Math.round(best);
  }

  function initRoot(root) {
    var bar = root.querySelector('[data-bbp-bar]');
    var mbar = root.querySelector('[data-bbp-mbar]');
    var parts = qsa(root, '[data-bbp-part]');
    var links = qsa(root, '[data-bbp-link]');
    var mlinks = qsa(root, '[data-bbp-mlink]');
    var cur = root.querySelector('[data-bbp-mbar-cur]');
    var count = root.querySelector('[data-bbp-mbar-count]');
    var prog = root.querySelector('[data-bbp-mbar-prog]');
    var mbtn = root.querySelector('[data-bbp-mbar-btn]');
    var list = root.querySelector('[data-bbp-mbar-list]');
    var shade = root.querySelector('[data-bbp-shade]');
    var mname = root.querySelector('[data-bbp-mbar-name]');
    var fullName = mname ? mname.textContent : '';
    var shortName = mname ? (mname.getAttribute('data-short') || '') : '';
    var barLabels = mlinks.map(function (a) { return a.getAttribute('data-bar') || a.getAttribute('data-label'); });
    var navIds = links.map(function (a) { return a.getAttribute('data-bbp-link'); });
    var lastTop = -1;
    var lastActive = -1;

    /* Phone bar name. The full name when it fits beside every section's label, otherwise the short name; that choice
       is made once per screen width, so the name doesn't switch as you scroll. A name that still won't fit beside
       the current label is cut back a word at a time. */
    var baseName = fullName;
    function nameFits() {
      var room = mname.getBoundingClientRect().width;
      mname.style.flexShrink = '0';
      var need = mname.getBoundingClientRect().width;
      mname.style.flexShrink = '';
      return need <= room + 0.01;
    }
    function trimName() {
      if (!mname) return;
      mname.textContent = baseName;
      if (!PHONE.matches || nameFits()) return;
      var words = baseName.split(' ');
      for (var k = words.length - 1; k > 0; k--) {
        mname.textContent = words.slice(0, k).join(' ') + '…';
        if (nameFits()) return;
      }
      mname.textContent = baseName;
    }
    function fitName() {
      if (!mname || !cur) return;
      baseName = fullName;
      mname.textContent = fullName;
      if (PHONE.matches && shortName && shortName !== fullName) {
        var shown = cur.textContent;
        for (var i = 0; i < barLabels.length; i++) {
          cur.textContent = barLabels[i];
          if (!nameFits()) { baseName = shortName; break; }
        }
        cur.textContent = shown;
      }
      trimName();
    }

    function barHeight() {
      if (PHONE.matches) return mbar ? mbar.offsetHeight : 0;
      return bar ? bar.offsetHeight : 0;
    }

    function update() {
      var top = headerBottom();
      if (top !== lastTop) {
        root.style.setProperty('--bbp-sticky-top', top + 'px');
        lastTop = top;
      }
      if (!navIds.length) return;
      var line = top + barHeight() + Math.min(160, window.innerHeight * 0.25);
      var active = 0;
      for (var i = 0; i < navIds.length; i++) {
        var el = document.getElementById(navIds[i]);
        if (el && el.getBoundingClientRect().top <= line) active = i;
      }
      if (active === lastActive) return;
      lastActive = active;
      links.forEach(function (a, i) {
        if (i === active) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      mlinks.forEach(function (a, i) {
        if (i === active) a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      });
      if (cur && mlinks[active]) {
        cur.textContent = barLabels[active];
        trimName();
      }
      if (count) count.textContent = (active + 1) + ' of ' + navIds.length;
      if (prog) prog.style.width = (((active + 1) / navIds.length) * 100).toFixed(2) + '%';
    }

    /* Keep checking for a moment after each scroll, so the bars follow the theme header as it slides in or out */
    var ticking = false;
    var settleUntil = 0;
    function loop() {
      update();
      if (Date.now() < settleUntil) window.requestAnimationFrame(loop); else ticking = false;
    }
    function onScroll() {
      settleUntil = Date.now() + 700;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(loop);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    var fitTimer = 0;
    window.addEventListener('resize', function () {
      window.clearTimeout(fitTimer);
      fitTimer = window.setTimeout(fitName, 150);
    });
    update();
    fitName();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitName);
    window.addEventListener('load', fitName);

    /* Phone list */
    function setList(open) {
      if (!list || !mbtn) return;
      mbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      list.hidden = !open;
      if (shade) {
        shade.hidden = !open;
        if (open && mbar) shade.style.top = Math.round(mbar.getBoundingClientRect().bottom) + 'px';
      }
    }
    if (mbtn) {
      mbtn.addEventListener('click', function () { setList(mbtn.getAttribute('aria-expanded') !== 'true'); });
    }
    if (shade) shade.addEventListener('click', function () { setList(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mbtn && mbtn.getAttribute('aria-expanded') === 'true') { setList(false); mbtn.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (mbtn && mbtn.getAttribute('aria-expanded') === 'true' && mbar && !mbar.contains(e.target)) setList(false);
    });

    /* Jump links: scroll with the bars accounted for */
    function jump(e) {
      var id = this.getAttribute('href').slice(1);
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      setList(false);
      var y = el.getBoundingClientRect().top + window.pageYOffset - headerBottom() - barHeight() + 1;
      window.scrollTo({ top: y, behavior: 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    }
    links.concat(mlinks).forEach(function (a) { a.addEventListener('click', jump); });

    /* Recipe tabs */
    qsa(root, '[data-bbp-tabs]').forEach(function (tl) {
      var tabs = qsa(tl, '[role="tab"]');
      function select(t, focus) {
        tabs.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(x.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) t.focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') n = tabs[0];
          if (e.key === 'End') n = tabs[tabs.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
    });

    /* Accordions */
    qsa(root, '[data-bbp-acc]').forEach(function (b) {
      var panel = document.getElementById(b.getAttribute('aria-controls'));
      function set(open) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      }
      if (b.hasAttribute('data-bbp-acc-mob-closed') && PHONE.matches) set(false);
      b.addEventListener('click', function () { set(b.getAttribute('aria-expanded') !== 'true'); });
    });

    /* Show all awards, More questions (phones) */
    qsa(root, '[data-bbp-awards-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.closest('[data-bbp-awards]');
        if (s) s.classList.add('is-open');
      });
    });
    qsa(root, '[data-bbp-faq-more]').forEach(function (b) {
      b.addEventListener('click', function () {
        var s = b.closest('[data-bbp-details]');
        if (s) s.classList.add('is-open');
      });
    });

    /* Judge.me links: open the full widget, and its form for Write a review.
       When Judge.me's own Write a review button is turned off, the write links and the invitation hide. */
    function jmWidget() { return document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-widget.jdgm-review-widget'); }
    function syncWrite() {
      var w = jmWidget();
      var can = !!(w && w.querySelector('.jdgm-write-rev-link'));
      qsa(root, '[data-bbp-jm-write], .bbp-reviews__invite').forEach(function (el) { el.style.display = can ? '' : 'none'; });
    }
    syncWrite();
    window.addEventListener('load', function () { setTimeout(syncWrite, 1500); });
    qsa(root, '[data-bbp-jm-read], [data-bbp-jm-write]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var w = jmWidget();
        if (!w) return;
        e.preventDefault();
        var y = w.getBoundingClientRect().top + window.pageYOffset - headerBottom() - 16;
        window.scrollTo({ top: y, behavior: 'smooth' });
        if (a.hasAttribute('data-bbp-jm-write')) {
          var open = w.querySelector('.jdgm-write-rev-link');
          var form = w.querySelector('.jdgm-form-wrapper');
          if (open && (!form || form.offsetParent === null)) open.click();
        }
      });
    });

    /* Mini Add to Cart in the desktop bar uses the theme's own form */
    qsa(root, '[data-bbp-main-atc]').forEach(function (b) {
      b.addEventListener('click', function () {
        var main = document.querySelector('.productView #product-add-to-cart') || document.getElementById('product-add-to-cart');
        if (main && !main.disabled) { main.click(); return; }
        var form = document.querySelector('form[action*="/cart/add"]');
        if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* The theme's bottom Add to Cart bar on phones. In stock, its button shows the price, as the desktop bar does
       (the bar at the top already names the product). Sold out, it and the desktop bar's button become
       SOLD OUT · NOTIFY ME and take you to the back-in-stock form in the buy box. Without the form, the desktop
       button stays a plain SOLD OUT and the phone bar stays hidden. */
    var stickyBar = document.querySelector('sticky-add-to-cart');
    var stickyBtn = document.getElementById('show-sticky-product');
    var price = root.getAttribute('data-bbp-price');
    var notifyInput = document.querySelector('[data-bbp-notify] input[type="email"]');
    if (root.hasAttribute('data-bbp-sold')) {
      if (notifyInput) {
        var toNotify = function (e) {
          e.preventDefault();
          e.stopPropagation();
          notifyInput.scrollIntoView({ block: 'center', behavior: PHONE.matches ? 'auto' : 'smooth' });
          notifyInput.focus({ preventScroll: true });
        };
        qsa(root, '[data-bbp-notify-go]').forEach(function (b) {
          b.disabled = false;
          b.classList.remove('bbp-btn--sold');
          b.classList.add('bbp-btn--outline');
          b.textContent = 'SOLD OUT · NOTIFY ME';
          b.addEventListener('click', toNotify);
        });
        if (stickyBar && stickyBtn) {
          stickyBtn.textContent = 'SOLD OUT · NOTIFY ME';
          stickyBar.setAttribute('data-bbp-notify-bar', '');
          /* Runs before the theme's own handler, which would open its Add to Cart panel */
          document.addEventListener('click', function (e) {
            if (e.target.closest && e.target.closest('#show-sticky-product')) toNotify(e);
          }, true);
        }
      }
    } else if (stickyBtn && price && stickyBtn.textContent.indexOf(price) === -1) {
      stickyBtn.textContent = stickyBtn.textContent.trim() + ' · ' + price;
    }
  }

  /* ---------- Add several products in one go ---------- */
  function refreshCart(cart) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var drawer = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
    var type = window.after_add_to_cart && window.after_add_to_cart.type;
    if (!drawer || type === 'cart') {
      window.location.href = (window.routes && window.routes.cart) || '/cart';
      return Promise.resolve();
    }
    return fetch(root + 'cart?view=ajax_side_cart', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (window.jQuery) window.jQuery(drawer).html(html); else drawer.innerHTML = html;
        qsa(document, '[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        if (window.cartStrings) {
          qsa(document, '[data-cart-text]').forEach(function (el) {
            el.textContent = cart.item_count === 1 ? window.cartStrings.item : window.cartStrings.items;
          });
        }
        qsa(document, '[data-free-shipping-wrapper]').forEach(function (w) { w.dispatchEvent(new Event('change', { bubbles: true })); });
        document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        document.body.classList.add('cart-sidebar-show');
      });
  }

  function addItems(btn) {
    var spec = btn.getAttribute('data-bbp-add') || '';
    var items = spec.split(',').filter(Boolean).map(function (pair) {
      var bits = pair.split(':');
      return { id: parseInt(bits[0], 10), quantity: parseInt(bits[1] || '1', 10) };
    }).filter(function (i) { return i.id; });
    if (!items.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var msg = btn.parentNode.querySelector('.bbp-btn-msg');
    if (msg) msg.remove();
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Couldn’t add those to your cart.');
          return j;
        });
      })
      .then(function () { return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
      .then(refreshCart)
      .catch(function (err) {
        var p = document.createElement('span');
        p.className = 'bbp-btn-msg';
        p.setAttribute('role', 'alert');
        p.textContent = err && err.message ? err.message : 'Couldn’t add those to your cart. Please try again.';
        btn.insertAdjacentElement('afterend', p);
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-bbp-add]');
    if (b && !b.disabled) { e.preventDefault(); addItems(b); }
  });

  /* ---------- Quick view from Pairs well with and recipe ingredients ----------
     A plain click on a card in the buy box's Pairs well with, or on a recipe ingredient that's another of our
     products, opens that product in the theme's quick view instead of leaving the page. Ctrl, Cmd, Shift and
     middle clicks still open the product page, and so does every click when the quick view is switched off. */
  var QV_LINKS = '.productView-complementary a[href*="/products/"], .bbp-ing a[href*="/products/"]';

  function quickViewHandle(a) {
    if (!document.querySelector('.halo-quick-view-popup')) return null;
    var m = /\/products\/([^\/?#]+)/.exec(a.getAttribute('href') || '');
    if (!m) return null;
    var here = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    if (here && here[1] === m[1]) return null;
    return decodeURIComponent(m[1]);
  }

  function openQuickView(handle) {
    /* The theme opens its quick view, and loads what it needs the first time, from a click on
       [data-open-quick-view-popup], so this hands it one */
    var t = document.createElement('button');
    t.type = 'button';
    t.hidden = true;
    t.setAttribute('data-open-quick-view-popup', '');
    t.setAttribute('data-product-handle', handle);
    document.body.appendChild(t);
    t.click();
    t.remove();
  }

  function markQuickViewLinks(scope) {
    qsa(scope, QV_LINKS).forEach(function (a) {
      if (quickViewHandle(a)) a.setAttribute('aria-haspopup', 'dialog');
    });
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest(QV_LINKS);
    var handle = a && quickViewHandle(a);
    if (!handle) return;
    e.preventDefault();
    openQuickView(handle);
  });

  function bootQuickViewLinks() {
    markQuickViewLinks(document);
    /* The Pairs well with cards arrive after the page loads */
    if (!window.MutationObserver) return;
    qsa(document, 'complementary-products').forEach(function (el) {
      new MutationObserver(function () { markQuickViewLinks(el); }).observe(el, { childList: true, subtree: true });
    });
  }

  function boot() { qsa(document, '[data-bbp]').forEach(initRoot); bootQuickViewLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector && e.target.querySelector('[data-bbp]');
    if (r) initRoot(r);
  });
})();